import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";

// Skema untuk satu item pembayaran dalam array 'data'
const PaymentItemSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    date_payment: z.string(),
    created_at: z.nullable(z.string()),
    payment_type: z.string(),
    // API mengembalikan angka sebagai string, kita akan memvalidasinya sebagai string
    // dan mengubahnya menjadi angka nanti di komponen (best practice)
    amount: z.string(),
    surcharge: z.string(),
    total_amount: z.string(),
    booking_room_id: z.string().uuid(),
    invoice_number: z.string(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    customer_name: z.string(),
    customer_surname: z.string(),
    booking_id: z.string().uuid(),
    // 'channex_ota_name' bisa null, jadi kita tandai sebagai .nullable()
    channex_ota_name: z.string().nullable(),
    room_type_id: z.string().uuid(),
    room_type_name: z.string(),
    room_id: z.string().uuid(),
    room_number: z.string(),
    user_id: z.string().uuid(),
    user_name: z.string(),
});

// Skema untuk keseluruhan respons API, yang membungkus array item pembayaran
// Perhatikan: API Anda tidak mengembalikan objek 'total', jadi kita tidak memasukkannya di sini.
// Total akan kita hitung di frontend.
export const PaymentReportResponseSchema = BaseResponseSchema(z.array(PaymentItemSchema));

// Mengekspor tipe untuk digunakan di seluruh aplikasi
export type PaymentReportResponseSchemaType = z.infer<typeof PaymentReportResponseSchema>;
export type PaymentItemType = z.infer<typeof PaymentItemSchema>;

// Anda bisa menghapus ekspor yang tidak perlu di bawah ini jika tidak digunakan
export { PaymentItemSchema as PaymentResponse };